export default "__VITE_ASSET__CkNoxeex__"